(ns client-portal.client.reports.components.trend-summary
  (:require [shared.core.amelia-light.components.components :as alc]
            [shared.core.style :as style]
            [shared.core.util :as util]))

(defn trend-summary
  "A card's `trend-summary` (see `ai-summary/with-chart-trend-summaries` on the
   server) as a table: a row per entry, a column per value column, each cell the
   report period's value with its trend arrow and the lookback's value in
   parentheses. `label-of` labels an entry's x value and `series-label-of` a value
   column without a label of its own. `default-x-label` heads the entries' column
   when the summary carries no `x-label` of its own."
  [{:keys [summary label-of series-label-of default-x-label]}]
  (let [{:keys [period basis unit x-label columns entries]} summary
        x-label (or x-label (if (= "label" basis) default-x-label ""))
        columns (or (not-empty columns)
                    (map #(select-keys % [:key]) (:values (first entries))))
        unit-of (into {}
                      (map (fn [{:keys [key] :as column}]
                             [key (if (contains? column :unit) (:unit column) unit)]))
                      columns)
        fmt (fn [k v] (if (number? v) (str (util/to-precision-num v :precision 1) (get unit-of k)) "–"))
        text-color (style/alc-color "Text/primary")]
    (when (not-empty entries)
      [:div {:style {:display :flex
                     :flex-direction :column
                     :gap 8}}
       [:div {:style {:color (style/alc-color "Text/secondary")
                      :font-size 13
                      :font-weight style/font-medium-weight}}
        (str "Trend Comparison"
             (when period (str " (vs. " period ")")))]
       [alc/table
        {:headers (into [{:label x-label}]
                        (map (fn [{:keys [key label]}] {:label (or label (series-label-of key))}))
                        columns)
         :rows (mapv (fn [{:keys [label display values]}]
                       {:cells (into [(or display (if (= "label" basis) (label-of label) (str label)))]
                                     (map (fn [{:keys [key current prior trend]}]
                                            {:label [:div {:style {:display :inline-flex
                                                                   :align-items :center
                                                                   :gap 2}}
                                                     [:span (fmt key current)]
                                                     (when-let [icon-type (case trend
                                                                            "up" :arrow-upward
                                                                            "down" :arrow-downward
                                                                            "same" :remove
                                                                            nil)]
                                                       [alc/material-icon {:icon-type icon-type
                                                                           :style {:color text-color
                                                                                   :font-size 14}}])
                                                     [:span {:style {:color (style/alc-color "Text/secondary")}}
                                                      (str "(" (fmt key prior) ")")]]}))
                                     values)})
                     entries)}]])))
